module.exports = __webpack_public_path__ + "static/media/calendarGray.2319c6a6.png";